import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import { withComponent } from 'react-emotion'

import { Text } from '../components/Layout'
import { Title, Subtitle, Rule } from '../components/Typography'
import { StyledLink } from '../components/StyledLink.js'

const Haiku = Text.withComponent('pre')

const errorPage = () => (
  <article>
    <Helmet>
      <title>No such page</title>
    </Helmet>
    <header>
      <Title fontSize={[4, 5]} fontWeight="7" lineHeight="title" mt={0} mb={3}>
        Error 404
      </Title>
      <Subtitle
        fontSize={[3, 4]}
        fontWeight="5"
        lineHeight="title"
        mt={3}
        mb={4}
      >
        The page you&rsquo;re looking for does not exist.
      </Subtitle>
      <Rule mt={4} mb={5} />
    </header>
    <main>
      {/* have to ugily do this because somewhere whitespace gets removed */}
      <Haiku fontSize={[2, 3]} fontFamily="monospace" lineHeight="title">
        I&rsquo;m sorry. <StyledLink to="/" text="Click here to go home" />.
        <br />
      </Haiku>
    </main>
  </article>
)

export default errorPage



// WEBPACK FOOTER //
// ./src/pages/404.js